//Styles
import { InputText } from "primereact/inputtext"
import assessStyles from "../../../styles/assessments/Assessment.module.css"
import formStyles from "../../../styles/assessments/ManagementForm.module.css"
import { InputNumber } from "primereact/inputnumber"
import { InputSwitch } from "primereact/inputswitch"
import { Button } from "primereact/button"

export default function OutcomeEntry({
  profile,
  disabled,
  onChange,
  onDelete,
  findFieldMeta,
}) {
  const scoreMinField = "scoreMin"
  const scoreMaxField = "scoreMax"
  const textField = "text"

  const scoreMinMeta = findFieldMeta(profile, scoreMinField)
  const scoreMaxMeta = findFieldMeta(profile, scoreMaxField)
  const textMeta = findFieldMeta(profile, textField)

  const changeValue = (key, value) => {
    let newProfile = { ...profile }
    newProfile[key] = value

    onChange(newProfile)
  }

  return (
    <div className={formStyles.suggestedOutcomeEntryLayout}>
      <div className={formStyles.suggestedOutcomeEntryScoreLabel}>Score</div>
      <div className={formStyles.suggestedOutcomeEntryScoreValue}>
        <InputNumber
          value={profile[scoreMinField]}
          onChange={(e) => {
            changeValue(scoreMinField, e.value)
          }}
          minFractionDigits={0}
          placeholder="Min"
          inputClassName={formStyles.suggestedOutcomeScore}
          disabled={disabled}
          className={scoreMinMeta.error ? "p-invalid" : undefined}
          tooltip="Minimum score"
          tooltipOptions={{ position: "bottom" }}
        />{" "}
        To{" "}
        <InputNumber
          value={profile[scoreMaxField]}
          onChange={(e) => {
            changeValue(scoreMaxField, e.value)
          }}
          minFractionDigits={0}
          placeholder="Max"
          inputClassName={formStyles.suggestedOutcomeScore}
          disabled={disabled}
          className={scoreMaxMeta.error ? "p-invalid" : undefined}
          tooltip="Maximum score, must be more than the minimum score"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
      <div className={formStyles.suggestedOutcomeEntryOutcomeLabel}>
        Outcome description*
      </div>
      <div className={formStyles.suggestedOutcomeEntryOutcomeValue}>
        <InputText
          value={profile[textField]}
          onChange={(e) => {
            changeValue(textField, e.target.value)
          }}
          className={`${formStyles.suggestedOutcomeDescription} ${
            textMeta.error ? "p-invalid" : ""
          }`}
          disabled={disabled}
        />
      </div>
      <div className={formStyles.suggestedOutcomeEntryParticipantLabel}>
        Participant
      </div>
      <div
        className={`${formStyles.suggestedOutcomeEntryParticipantValue} ${assessStyles.switchControl}`}
      >
        <InputSwitch
          checked={profile.visibleToParticipant}
          onChange={(e) => {
            changeValue("visibleToParticipant", e.value)
          }}
          tooltip="Indicates if this outcome is visible to participant users"
          tooltipOptions={{ position: "bottom" }}
          disabled={disabled}
          className={formStyles.inputSwitch}
        />
      </div>
      <div className={formStyles.suggestedOutcomeEntryStaffLabel}>Staff</div>
      <div
        className={`${formStyles.suggestedOutcomeEntryStaffValue} ${assessStyles.switchControl}`}
      >
        <InputSwitch
          checked={profile.visibleToStaff}
          onChange={(e) => {
            changeValue("visibleToStaff", e.value)
          }}
          tooltip="Indicates if this outcome is visible to staff users"
          tooltipOptions={{ position: "bottom" }}
          disabled={disabled}
        />
      </div>
      <div className={formStyles.suggestedOutcomeEntryAction}>
        <span className={`material-icons`}>
          <Button
            icon="pi pi-times"
            type="button"
            onClick={() => {
              onDelete()
            }}
            className={assessStyles.actionButtonPurple}
            tooltip="Delete outcome"
            tooltipOptions={{ position: "bottom" }}
            disabled={disabled}
          />
        </span>
      </div>
      <div
        className={`${formStyles.suggestedOutcomeEntryErrorScore} ${formStyles.outcomeEntryError}`}
      >
        {scoreMinMeta.error && scoreMinMeta.touched ? (
          <p>{scoreMinMeta.error}</p>
        ) : null}
        {scoreMaxMeta.error &&
        scoreMaxMeta.touched &&
        scoreMaxMeta.error !== scoreMinMeta.error ? (
          <p>{scoreMaxMeta.error}</p>
        ) : null}
      </div>
      <div
        className={`${formStyles.suggestedOutcomeEntryErrorOutcome} ${formStyles.outcomeEntryError}`}
      >
        {textMeta.error && textMeta.touched ? <p>{textMeta.error}</p> : null}
      </div>
    </div>
  )
}
